import { j as l } from "./AccesRecoveryIcon-CUPieIxT.js";
const s = () => /* @__PURE__ */ l.jsxs("svg", { viewBox: "0 0 78 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ l.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M34.55 20c0-11.046 8.831-20 19.725-20s19.726 8.954 19.726 20-8.832 20-19.726 20S34.55 31.046 34.55 20",
      fill: "#50AF95"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M54.275 1C43.946 1 35.55 9.493 35.55 20s8.396 19 18.725 19 18.726-8.493 18.726-19S64.604 1 54.275 1m0-1C43.381 0 34.55 8.954 34.55 20s8.831 20 19.725 20 19.726-8.954 19.726-20S65.168 0 54.275 0",
      fill: "#489E87"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M56.616 21.578c-.13.01-.806.051-2.313.051a50 50 0 0 1-2.349-.051c-4.632-.207-8.089-1.026-8.089-2.007s3.457-1.8 8.09-2.01v3.201c.302.022 1.17.074 2.368.074 1.438 0 2.158-.06 2.288-.073v-3.2c4.623.21 8.073 1.029 8.073 2.008 0 .978-3.449 1.798-8.072 2.006zm0-4.346v-2.864h6.45V10H45.504v4.368h6.45v2.863c-5.243.245-9.185 1.3-9.185 2.564s3.942 2.319 9.185 2.565v9.179h4.661v-9.183c5.232-.244 9.167-1.298 9.167-2.562s-3.932-2.316-9.165-2.562",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      d: "M38.866 20C38.866 9.3 30.311.625 19.757.625 9.204.625.648 9.299.648 20c0 10.7 8.555 19.375 19.11 19.375 10.552 0 19.108-8.674 19.108-19.375",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M38.25 20c0 10.355-8.28 18.75-18.492 18.75S1.265 30.355 1.265 20 9.545 1.25 19.758 1.25 38.25 9.645 38.25 20M13.186 37.336c5.147-7.417 6.917-13.903 6.927-18.214s-2.322-7.303-5.285-7.928c-.587-.124-1.203-.26-1.748-.231-.547.028-2.199.037-3.26-.418-1.666-.714-2.83-2.162-2.609-3.923a.24.24 0 0 1 .111-.172.24.24 0 0 1 .202-.022c5.65 1.895 14.632 5.008 24.967 3.19.164-.028.312.106.281.27-.233 1.258-1.233 2.27-2.323 2.27-1.184 0-3.736-.986-5.139-.34-1.131.523-2.642 3.268-2.022 6.861 1.108 6.413 4.527 4.922 6.695 2.45-.812 4.12-2.168 7.417-7.586 6.593-.813 2.472-1.815 6.043-9.21 9.614m10.295-30.97c1.053-1.349 1.258-2.964.457-3.607s-2.304-.072-3.358 1.276S19.323 7 20.123 7.642s2.304.072 3.358-1.277",
      fill: "url(#a)"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M.023 20c0-11.038 8.828-20 19.734-20s19.734 8.963 19.734 20-8.827 20-19.734 20S.023 31.037.023 20M19.758 1.25C9.558 1.25 1.273 9.636 1.273 20c0 10.363 8.284 18.75 18.485 18.75S38.24 30.364 38.24 20c0-10.363-8.283-18.75-18.483-18.75",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      d: "M38.866 20C38.866 9.3 30.311.625 19.757.625 9.204.625.648 9.299.648 20c0 10.7 8.555 19.375 19.11 19.375 10.552 0 19.108-8.674 19.108-19.375",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M38.25 20c0 10.355-8.28 18.75-18.492 18.75S1.265 30.355 1.265 20 9.545 1.25 19.758 1.25 38.25 9.645 38.25 20M13.186 37.336c5.147-7.417 6.917-13.903 6.927-18.214s-2.322-7.303-5.285-7.928c-.587-.124-1.203-.26-1.748-.231-.547.028-2.199.037-3.26-.418-1.666-.714-2.83-2.162-2.609-3.923a.24.24 0 0 1 .111-.172.24.24 0 0 1 .202-.022c5.65 1.895 14.632 5.008 24.967 3.19.164-.028.312.106.281.27-.233 1.258-1.233 2.27-2.323 2.27-1.184 0-3.736-.986-5.139-.34-1.131.523-2.642 3.268-2.022 6.861 1.108 6.413 4.527 4.922 6.695 2.45-.812 4.12-2.168 7.417-7.586 6.593-.813 2.472-1.815 6.043-9.21 9.614m10.295-30.97c1.053-1.349 1.258-2.964.457-3.607s-2.304-.072-3.358 1.276S19.323 7 20.123 7.642s2.304.072 3.358-1.277",
      fill: "#3120DF"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M.023 20c0-11.038 8.828-20 19.734-20s19.734 8.963 19.734 20-8.827 20-19.734 20S.023 31.037.023 20M19.758 1.25C9.558 1.25 1.273 9.636 1.273 20c0 10.363 8.284 18.75 18.485 18.75S38.24 30.364 38.24 20c0-10.363-8.283-18.75-18.483-18.75",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsxs("linearGradient", { id: "a", x1: "77.879", y1: "3.85", x2: "66.193", y2: "46.07", gradientUnits: "userSpaceOnUse", children: [
    /* @__PURE__ */ l.jsx("stop", { stopColor: "#031CE8" }),
    /* @__PURE__ */ l.jsx("stop", { offset: "1", stopColor: "#008DEB" })
  ] }) })
] });
export {
  s as F
};
